import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import useViewPort from "../../../hook/useViewPort";
import ImageType4 from "../../molecules/image-type-4";
import { currentUser } from "@quintype/bridgekeeper-js";
import { userFavouritesApi } from "../../utils/user-favourites-api";
import "./user-media-favourites.m.css";
import { getCollections } from "../../../../api/utils";
import { useSelector } from "react-redux";
import { ResponsiveImage } from "@quintype/components";
import axios from "axios";

const UserMediaFavourites = ({ qtConfig }) => {
  const { viewports } = useViewPort();
  const [userId, setUserId] = useState(null);
  const [yesterdayMedia, setYesterdayMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const defaultImgState = useSelector((state) => get(state, ["qt", "config"]));
  const defaultImage = get(defaultImgState, ["publisher-attributes", "defaultImageKey"], "");
  const arrSections = qtConfig?.sections ?? [];

  const findSectionById = function(sections, id) {
    return sections.find(s => s.id === id) || null;
  }

  const findTopParentRecursive = function(sections, sectionId, originalSection = null) {
    const section = findSectionById(sections, sectionId);

    // Strict base case: section not found OR has no parent
    if (!section || !section["parent-id"] || section["parent-id"] <= 0) {
      // Set originalSection if this is the first call
      if (!originalSection && section) originalSection = section;

      return { original: originalSection, parent: section };
    }

    // Set originalSection on the first call
    if (!originalSection) originalSection = section;

    // Recursive step: go find the parent
    return findTopParentRecursive(sections, section["parent-id"], originalSection);
  }

  useEffect(() => {
    const fetchUserId = async () => {
      try {
        const currentUserResp = await currentUser();
        const userId = currentUserResp?.user?.id || null;
        setUserId(userId);
      } catch (error) {
        console.error("Error fetching user id:", error);
      }
    };
    fetchUserId();
  }, []);

  const loadUserFavData = async (userId) => {
    try {
      const favourites = await userFavouritesApi(userId);
      return Array.isArray(favourites) ? favourites : [];
    } catch (error) {
      console.error("Error fetching user favourites:", error);
      return [];
    }
  };

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      const arrSectionCollectionDetails = await loadUserFavData(userId);
      setYesterdayMedia(arrSectionCollectionDetails);
    };

    if (userId) {
      fetchData();
    }
  }, [userId]);

  const handleRemoveFav = async (assetId) => {
    try {
      if (!userId) return;

      const response = await axios.post("/user-favourites/delete", { user_id: userId, asset_id:assetId });
      const arrSectionCollectionDetails = await loadUserFavData(userId);
      setYesterdayMedia(arrSectionCollectionDetails);
    } catch (error) {
      console.error("Error deleting favourite:", error);
    }
  };

  return (
    Array.isArray(yesterdayMedia) && yesterdayMedia.length > 0 &&
    <div styleName="container">
      <div styleName="history-headline" className={viewports ? viewports : ""}>
        <h2>Suosikit</h2>
      </div>

      <div styleName="image-grid" className={viewports ? viewports : ""}>
        {yesterdayMedia.map((objFavItem, index) => {
          if (!objFavItem?.id) {return;}
          let contentType = objFavItem?.metadata["content-type"]?.[0]?.name;
          let behindPaywall = objFavItem?.metadata["behind-paywall"]?.[0]?.name || null;
          // new logic to build slug
          const sectionId = objFavItem?.metadata?.section?.[0]?.id;
          const { original, parent } = findTopParentRecursive(arrSections, sectionId);
          let slug = original?.slug || "";

          if (parent?.slug === "lammas") {
            slug = `lammas/${original?.slug}`;
          }
          // new logic to build slug

          const collectionHeroImgS3Key = objFavItem?.metadata?.["cover-image"]?.["cover-image-s3-key"] ?? defaultImage;
          if (!collectionHeroImgS3Key) return null;

          return (
            <div key={objFavItem?.metadata?.id || index} id={objFavItem?.metadata?.id} styleName="image-container" className={viewports ? viewports : ""}>
              <Link href={slug}>
                <div styleName="responsive-img">
                  {collectionHeroImgS3Key && collectionHeroImgS3Key && (
                    <figure>
                      <ResponsiveImage
                        aspectRatio={[16, 9]}
                        defaultWidth={480}
                        widths={[250, 480, 640]}
                        slug={collectionHeroImgS3Key}
                        key={index}
                        alt={collectionHeroImgS3Key}
                      />
                    </figure>
                  )}
                  {/* Delete icon on bottom-right */}
                  <div styleName="del-fav-icon-wrapper">
                    <button styleName="symbol-selected" onClick={(e) => {e.preventDefault();e.stopPropagation();handleRemoveFav(objFavItem?.metadata?.id);}}>
                      <img alt="video-logo" src="/icons/favorites-symbol-added-white.svg" styleName="fav-icon" />
                    </button>
                  </div>
                  {/* Subscription icon on top-left */}
                  {
                    behindPaywall ==="Kyllä" &&
                    (<div styleName="subscription-wrapper">
                      <img
                        alt="subscription-icon"
                        src="/icons/under-subcription.svg"
                        styleName="subscription-image"
                      />
                    </div>)
                  }
                  {/* Audio/Video icon on top-right */}
                  {
                    contentType &&
                    (<div styleName="audio-video-wrapper">
                      {contentType === "Audio" && (
                        <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon" />
                      )}
                      {contentType === "Video" && (
                        <img alt="video-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon" />
                      )}
                    </div>)
                  }
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UserMediaFavourites;
